<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- MODAL -->
  <div
    class="modal fade"
    id="comitente-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-if="modal"
    style="margin-top: 30px"
    @close="visible = false"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Cadastrar comitente</h4>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title" style="color: white">Cadastro de comitente</h3>
                  </div>

                  <div class="card-body">
                    <div class="row">
                      <!-- NOME -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Nome completo</label>
                          <input
                            class="form-control"
                            id="nome_completo"
                            v-model="formData.nome"
                            @blur="upper('nome')"
                            style="text-transform: uppercase"
                          />

                          <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- ENDERECO ESTADO -->
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="endereco_estado">UF</label>

                          <select
                            class="custom-select rounded-0"
                            id="endereco_estado"
                            v-model="formData.estado"
                            @change="buscarCidades()"
                            style="text-transform: uppercase"
                            :disabled="disable_estado"
                          >
                            <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                              {{ estado.nome }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ENDERECO CIDADE -->
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="endereco_cidade">Cidade</label>

                          <select
                            class="custom-select rounded-0"
                            :disabled="disable_cidade"
                            id="endereco_cidade"
                            v-model="formData.cidade"
                            style="text-transform: uppercase"
                          >
                            <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">
                              {{ cidade.nome }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- CPF/CNPJ -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="cpf_cnpj">CPF/CNPJ</label>
                          <input
                            class="form-control"
                            id="cpf_cnpj"
                            v-model="formData.cpf_cnpj"
                            @blur="upper('cpf_cnpj')"
                            style="text-transform: uppercase"
                          />
                        </div>
                      </div>

                      <!-- EMAIL -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="email">Email</label>
                          <input class="form-control" id="email" type="email" v-model="formData.email" />
                        </div>
                      </div>

                      <!-- ENDEREÇO -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="endereco">Endereço</label>
                          <input
                            class="form-control"
                            id="endereco"
                            v-model="formData.endereco"
                            @blur="upper('endereco')"
                            style="text-transform: uppercase"
                          />
                        </div>
                      </div>

                      <!-- FONE -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="fone">Fone</label>
                          <input class="form-control" id="fone" v-model="formData.fone" @blur="upper('fone')" style="text-transform: uppercase" />
                        </div>
                      </div>

                      <!-- NOME CONTATO -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="nome_contato">Nome contato</label>
                          <input
                            class="form-control"
                            id="nome_contato"
                            v-model="formData.nome_contato"
                            @blur="upper('nome_contato')"
                            style="text-transform: uppercase"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Cadastrar</button>

                    <button data-toggle="modal" id="cancelar_comitente" data-target="#comitente-modal" class="btn btn-danger">Voltar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- PÁGINA -->
  <div class="row" v-if="!modal">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de comitente</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- NOME -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="exampleInputEmail1">Nome completo</label>
                <input
                  class="form-control"
                  id="nome_completo"
                  placeholder="Nome"
                  v-model="formData.nome"
                  @blur="upper('nome')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade" style="text-transform: uppercase">
                  <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- CPF/CNPJ -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="cpf_cnpj">CPF/CNPJ</label>
                <input
                  class="form-control"
                  id="cpf_cnpj"
                  placeholder="CPF ou CNPJ"
                  v-model="formData.cpf_cnpj"
                  @blur="upper('nome')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- EMAIL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="email">Email</label>
                <input class="form-control" id="email" type="email" placeholder="Email" v-model="formData.email" />
              </div>
            </div>

            <!-- ENDEREÇO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco">Endereço</label>
                <input
                  class="form-control"
                  id="endereco"
                  placeholder="Endereço"
                  v-model="formData.endereco"
                  @blur="upper('endereco')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- FONE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="fone">Fone</label>
                <input
                  class="form-control"
                  id="fone"
                  placeholder="Fone"
                  v-model="formData.fone"
                  @blur="upper('fone')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- NOME CONTATO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="nome_contato">Nome contato</label>
                <input
                  class="form-control"
                  id="nome_contato"
                  placeholder="Nome contato"
                  v-model="formData.nome_contato"
                  @blur="upper('nome_contato')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateFields()">Cadastrar</button>
          <a type="submit" href="/admin/comitentes" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "cidades_buscadas", "modal", "action", "estado_selecionado", "cidade_selecionada", "voltar"],

  components: { Loading },

  data() {
    return {
      nome: "",
      isLoading: false,
      cidades: [],
      disable_cidade: false,
      disable_cidade: false,
    };
  },

  setup() {
    const formData = reactive({
      nome: "",
      endereco: "",
      cpf_cnpj: "",
      fone: "",
      nome_contato: "",
      cidade: "",
      estado: "",
      email: "",
    });

    const rules = computed(() => {
      return {
        nome: { required },
      };
    });

    const validarCPFOuCNPJ = (cpf_cnpj) => {
      //TENTANDO VALIDAR COMO CPF
      cpf_cnpj = cpf_cnpj.replace(/\D/g, "");
      if (cpf_cnpj.toString().length != 11 || /^(\d)\1{10}$/.test(cpf_cnpj)) result = false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf_cnpj
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf_cnpj.substring(j, j + 1)) result = false;
      });

      //TENTANDO VALIDAR COMO CNPJ
      if (!result) {
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var c = String(cpf_cnpj).replace(/[^\d]/g, "");

        if (c.length !== 14) return false;

        if (/0{14}/.test(c)) return false;

        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
        if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
        if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

        return true;
      } else {
        return result;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    if (this.modal) {
      document.getElementById("cancelar_comitente").click();
    }

    this.cidades = this.cidades_buscadas;

    if (this.estado_selecionado) {
      this.formData.estado = this.estado_selecionado;
      this.disable_estado = true;
    }

    if (this.cidade_selecionada) {
      this.formData.cidade = this.cidade_selecionada;
      this.disable_cidade = true;
    }
  },

  methods: {
    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        nome: this.formData.nome,
        endereco: this.formData.endereco,
        cpf_cnpj: this.formData.cpf_cnpj,
        fone: this.formData.fone,
        nome_contato: this.formData.nome_contato,
        cidade_id: this.formData.cidade,
        estado_id: this.formData.estado,
        email: this.formData.email,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/comitente/store`, data)
        .then((response) => {
          if (this.modal) {
            this.showSuccessMessage("Comitente cadastrado!");
            this.action(response.data.id);
            this.isLoading = false;

            this.action(0);
            document.getElementById("cancelar_comitente").click();
          } else {
            this.isLoading = false;

            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Comitente cadastrado", "/admin/comitentes");
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          this.formData.cidade = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 900px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 700px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
